export default __webpack_public_path__ + "static/media/foot-left-side.1047d019.png";